import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import localization from "../../services/localization";
import { useDepartmentsStore } from "context/useDepartmentsStore";
import { useModulesStore } from "context/useModulesStore";
const Breadcrumbs = ({
  role,
  language,
  selectedPrompt,
  moduleId,
  departmentId,
  selectedHistory,
}) => {
  const { departments, isDepartmentsLoading } = useDepartmentsStore();
  const { modules, isModulesLoading } = useModulesStore();
  const [departmentName, setDepartmentName] = useState(null);
  const [moduleName, setModuleName] = useState(null);
  const navigate = useNavigate();
  const hoverStyle = "transition-colors duration-200 hover:text-[#ff9800]";

  useEffect(() => {
    if (!isDepartmentsLoading && departmentId && departments?.length) {
      const department = departments.find((d) => d.id === departmentId);
      setDepartmentName(department?.name || null);
    }
  }, [departments, departmentId, isDepartmentsLoading]);

  useEffect(() => {
    if (!isModulesLoading && moduleId && modules?.length) {
      const module = modules.find((m) => m.id === moduleId);
      setModuleName(module?.title || module?.name || null);
    }
  }, [modules, moduleId, isModulesLoading]);

  return (
    <div
      className="sticky w-full bg-[var(--secondary-bg)] border-b border-gray-300"
      // style={{ top: "70px" }}
    >
      <div className="flex items-center py-3 space-x-2 pl-4">
        <button
          onClick={() => navigate(`/departments`)}
          className="text-sm font-medium text-description breadcrumb-hover"
        >
          {localization.home || "Home"}
        </button>
        <span className="text-gray-400 select-none">/</span>
        <button
          onClick={() => navigate(`/departments`)}
          className="text-sm font-medium text-description breadcrumb-hover"
        >
          {departmentName || localization.department || "Department"}
        </button>

        {(role === "administrative" || role === "teacher") && (
          <>
            <span className="text-gray-400 select-none">/</span>
            <button
              onClick={() => navigate(`/services/${departmentId}`)}
              className="text-sm font-medium text-description breadcrumb-hover"
            >
              {moduleName || localization.modules || "Modules"}
            </button>
            {selectedPrompt == null && (
              <>
                <span className="text-gray-400 select-none">/</span>
                <button
                  onClick={() =>
                    navigate(`/prompt-categories/${moduleId}/${departmentId}`)
                  }
                  className="text-sm font-medium text-description breadcrumb-hover"
                >
                  {localization.categories || "Categories"}
                </button>
              </>
            )}
            {selectedPrompt?.title && (
              <>
                <span className="text-gray-400 select-none">/</span>
                <button
                  onClick={() =>
                    navigate(`/prompt-categories/${moduleId}/${departmentId}`)
                  }
                  className="text-sm font-medium text-description breadcrumb-hover"
                >
                  {selectedPrompt.title?.[language] ||
                    selectedPrompt.title?.It ||
                    selectedPrompt.title?.En ||
                    "Prompt"}
                </button>
              </>
            )}
            {selectedHistory?.title && (
              <>
                <span className="text-gray-400 select-none">/</span>
                <span
                  className="text-sm font-semibold "
                  style={{ color: "var(--module-card-description-color)" }}
                >
                  {selectedHistory.title || "History"}
                </span>
              </>
            )}
          </>
        )}

        {role === "student" && (
          <>
            {selectedPrompt?.title && (
              <>
                <span className="text-gray-400 select-none">/</span>
                <span
                  className="text-sm font-semibold "
                  style={{ color: "var(--module-card-description-color)" }}
                >
                  {selectedPrompt.title?.[language] ||
                    selectedPrompt.title?.It ||
                    selectedPrompt.title?.En ||
                    "Prompt"}
                </span>
              </>
            )}
            {selectedHistory?.title && (
              <>
                <span className="text-gray-400 select-none">/</span>
                <span
                  className="text-sm font-semibold "
                  style={{ color: "var(--module-card-description-color)" }}
                >
                  {selectedHistory.title || "History"}
                </span>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Breadcrumbs;
